import { CustomerAccountLite, getAccountsLite } from '../../Services/serviceURL';
import { CustomerLite } from '../Plants/CreatePlant';

type CustomerListItem = {
  id: string;
  customerId: string;
  customerName: string;
  soldTo?: string;
};

const mapAccountToCustomer = (
  customer: CustomerAccountLite,
  index: number
): CustomerListItem => ({
  id: customer.id || `customer-${index}`,
  customerId: customer.customerId,
  customerName: customer.customerName,
  soldTo: customer.salesDistrictCustomer || customer.salesDistrict || '',
});

export const dedupeCustomersByCustomerId = (customers: CustomerListItem[]): CustomerListItem[] => {
  const seen = new Set<string>();
  return customers.filter((customer) => {
    if (seen.has(customer.customerId)) {
      return false;
    }
    seen.add(customer.customerId);
    return true;
  });
};

export const fetchSummaryCustomers = async (): Promise<CustomerLite[]> => {
  const customerAccountsData = await getAccountsLite();
  if (!Array.isArray(customerAccountsData)) {
    return [];
  }

  const validCustomers = customerAccountsData.map(mapAccountToCustomer);
  return dedupeCustomersByCustomerId(validCustomers);
};
